<style lang="less" scoped>
  .td_left {width: 9.375rem;text-align-last: left;text-indent: .625rem;background-color: #fcfcfc;}
  .after {text-align: left;background-color: #fcfcfc;}
  .after .el-button {height: 2.5rem;}
  .f_red {color: red;margin-right: .3125rem;}
  .f_hid {color: #ffffff;margin-right: .3125rem;}
  tr,td {border: .0625rem solid #f5eeee;padding: .3125rem;border-bottom: .0625rem solid #f5eeee;}
  .tr .td {float: left;}
  .tr {width: 100%;height: 3.125rem;}
  .td {margin-left: .625rem;}
  table {border-collapse: collapse;width: 100%;}
  .el-checkbox__inner {border-radius: 50%;}
  .first .introduce {width: 100%;}
  .first /deep/ .el-input {width: 25rem;}
  .level /deep/ .el-input {width: 12.5rem;}
  .ssgj_tr /deep/ .el-input {width: 25rem;}
  .edui-default /deep/ .edui-editor-iframeholder {height: 40%;}
  .el-form-item {margin-bottom: 0;float: left;}
  .jianjie_tr .el-form-item {width: 100%;}
  .catid_tr .el-form-item:nth-of-type(2) {margin-left: .625rem;}
  .tr2 .el-form-item:nth-of-type(2) {margin-left: .625rem;}
  /deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail {position: absolute;margin: auto;top: -624.9375rem;right: -624.9375rem;bottom: -624.9375rem;left: -624.9375rem;height: auto}
  .formBox {padding-bottom: 4.375rem;}
  .btnfixed {margin: 0rem auto;height: 3.75rem;z-index: 19999;}
  .btnfixed .el-button {height: 2.5rem;margin: .625rem auto;}
  .btnfixed {position: fixed;bottom: 0;left: 0;right: 0;height: 3.75rem;background: #f8f4f4;margin-left: 15rem;background-color: #dff0d8;}
  /deep/.el-form-item__error {font-size: 1rem;height: 2.5rem;line-height: 2.5rem;float: right;margin-left: .625rem;position:static;padding-top: 0;}
  /deep/.el-icon-close-tip {display: none;}
  /deep/.el-dialog__wrapper {z-index: 20000 !important;}
  /deep/.hide .el-upload--picture-card {display: none;}
  /deep/.el-dialog {width: 30%;height: 37%;}
  /deep/.dialog-footer {margin-top: 30%; margin-right: 34%;}
</style>
<template>
  <div class="first" id="first">
    <el-form ref="form" :model="form" :rules="rules" class="formBox">
      <table>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('catid')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>所属分类
          </td>
          <td class="after">
            <el-form-item>
              <el-select clearable v-model="form.type" placeholder="请选择分类" class="select classification">
                <el-option v-for="item in classifydata" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('title')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>问题
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.question" class="input title" @blur="detection(11, 1, form.title)"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="jianjie_tr">
          <td class="td_left">
            <span v-if="isMandatory('introduce')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>选项
          </td>
          <td class="after">
            <el-form-item>
              <el-input type="textarea" placeholder="选项和选项之间用 ';' 隔开" v-model="form.answer" :rows="3" class="introduce" style="font-size: .9375rem;" ></el-input>
            </el-form-item>
          </td>
        </tr>
      </table>
    </el-form>
    
    <div class="btnfixed">
      <el-button type="success" @click="addfn()" v-if="this.$route.path === '/Kyzxfwgl'">添加</el-button>
      <el-button type="success" @click="modification" v-else-if="this.$route.path === '/KyzxfwUpdate' && this.datastatus === false">确定</el-button>
      <el-button type="success" @click="isPass()" v-else-if="this.$route.path === '/KyzxLook'">通过</el-button>

      <el-button @click="cancelfn()" v-if="this.$route.path === '/Kyzxfwgl'">取消</el-button>
      <el-button @click="backtrack" v-else-if="this.$route.path === '/KyzxfwUpdate'">返回</el-button>
      <el-button type="danger" @click="notPass()" v-else-if="this.$route.path === '/KyzxLook'">不通过</el-button>
      <el-button  @click="backtrackLook()" v-if="this.$route.path === '/KyzxLook'">返回</el-button>
    </div>
  </div>
</template>
<script>
/**
 * 何宽
 * 矿业资讯后台添加页
 */
import {mapState} from 'vuex'
// import E from 'wangeditor'
export default {
  components: {
  },

  props: ['updataID'],
  data()
  {
    //链接验证规则
    let InputFromurl = (rule, value, callback) =>
    {
      let regtel = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?/
      if (value)
      {
        if (!regtel.test(value))
          callback(new Error('请输入正确来源链接，http://www.'))
        else
          callback()
      }
      else
        callback()
    }
    return {
      url: '',
      checked_External_links: false,
      form: {
        type: null,
        question: '',
        answer: ''
      },
      forms: {
        textareas: ''
      },
      datastatus: false,
      username: '',
      // 富文本对象
      editor: null,
      //所属分类数据
      classifydata: [
        { value: 1, label: '矿业咨询服务' },
        { value: 2, label: '法律服务' },
        { value: 3, label: '常见问题' }
      ],
      //预览弹框
      dialogVisible: false,
      //预览路径
      dialogImageUrl: '',
      fileList: [{url: ''}],
      //审核
      examine: '',
      examineInfo: '',

      dialogFormVisible: false,

      //rules对象的属性名要与表单中prop绑定的名字一致
      rules: {
        fromurl: [
          { validator: InputFromurl, trigger: 'blur' }
        ]
      },
      
      level_data: [
        { value: '1', label: '1 级 网站首页推荐' },
        { value: '2', label: '2 级' }
      ],
      ssgj_data: [
        { value: 0, label: '不限地区' },
        { value: 2, label: '中国' },
        { value: 3, label: '印度尼西亚' },
        { value: 4, label: '马来西亚' },
        { value: 5, label: '菲律宾' },
        { value: 6, label: '新加坡' },
        { value: 7, label: '泰国' },
        { value: 8, label: '文莱' },
        { value: 9, label: '越南' },
        { value: 10, label: '老挝' },
        { value: 11, label: '缅甸' },
        { value: 12, label: '柬埔寨' },
        { value: 13, label: '其它' },
        { value: 14, label: '东帝汶' }
      ],

      //表名
      tabname: 'dmcn_article_24',
      tabContentname: 'dmcn_article_data_24',
      //fld表数据
      fldData: [],
      fldContentData: [],
      hideUploadEdit: false

    }
  },
  // 根据左侧菜单栏获取模块id
  computed:
  {
    ...mapState({
      curID: state => state.NavID
    })
  },
  // watch:
  // {
  //   curID:
  //   {
  //     handler(nval, oval)
  //     {
  //       //获取分类下拉列表
  //       window.public.getFldvalue(nval, 'catid').then((ret) =>
  //       {
  //         this.classifydata = []
  //         ret.forEach((item) => this.classifydata.push({ value: item.id, label: item.dispc }))
  //       })
  //     },
  //     immediate: true
  //   }
  // },
  async created()
  {
    //创建富文本编辑器
    setTimeout(() =>
    {
      let that = this
      window.public.createEditor(that)
    }, 50)
    // //创建富文本编辑器
    // setTimeout(() =>
    // {
    //   // let that = this
    //   // window.public.createEditor(that)

    //   const editor = new E('#editor')
    //   // base64 保存图片
    //   editor.config.uploadImgShowBase64 = false

    //   // 配置 server 接口地址
    //   editor.config.uploadImgServer = 'http://192.168.2.201:8083/svr/DocSvr?cmd=upload&major=11&minor=1&username=admin&fid=11&sys=11&dir=&entityid=1&glid=0&task=Dmky'

    //   editor.config.customUploadImg = function(resultFiles, insertImgFn)
    //   {
    //     console.log(resultFiles)
    //     console.log(insertImgFn)
    //     let Ip = window.location.hostname
    //     let UrlType = ''
    //     if (Ip === '127.0.0.1')
    //       UrlType = 'svr/DocSvr'
    //     else if (Ip === 'localhost')
    //       UrlType = 'svr/DocSvr'
    //     else
    //       UrlType = 'DocSvr'

    //     let data = {
    //       cmd: 'upload',
    //       major: 11,
    //       minor: 1,
    //       entityid: 1,
    //       username: 'name',
    //       fid: 1,
    //       sys: 11,
    //       task: '',
    //       dir: '',
    //       glid: '0'
    //     }
    //     let params = {
    //       url: UrlType,
    //       title: '',
    //       tip: '',
    //       data: data
    //     }


    //     // let params = {
    //     //   cmd: 'upload'
    //     // }

    //     window.post.getDocSvr(params).then(ret =>
    //     {
    //     })

    //     // let prefix = ''
    //     // if (Ip === 'www.camining.cn')
    //     //   prefix = 'http://www.camining.cn/uploadfile/'
    //     // else if (Ip === 'camining.cn')
    //     //   prefix = 'http://www.camining.cn/uploadfile/'
    //     // else
    //     //   prefix = 'http://192.168.2.201:8083/gisdm/uploadfile/'
    //     // insertImgFn(`${prefix}${resultFiles[0].name}`)
    //   }

    //   // 关闭粘贴样式的过滤
    //   editor.config.pasteFilterStyle = false
    //   // 配置 onchange 回调函数，将数据同步到 vue 中
    //   editor.config.onchange = (newHtml) =>
    //   {
    //     this.form.content = newHtml
    //   }
    //   // 隐藏插入网络图片的功能
    //   editor.config.showLinkImg = false
    //   // 限制大小
    //   // editor.config.uploadImgMaxSize = 12 * 1024 * 1024 // 2M
    //   // 限制类型
    //   editor.config.uploadImgAccept = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
    //   // 创建编辑器
    //   editor.create()
    //   this.editor = editor
    // }, 50)
    this.fldData = await window.public.validation(this.tabname)
    this.fldContentData = await window.public.validation(this.tabContentname)
    this.isgetData()
    //根据用户判断审核状态
    let userInfo = JSON.parse(localStorage.getItem('userMsg'))
    this.username = userInfo.userno
    if (userInfo.userno === 'admin')
      this.examine = 0
    else
      this.examine = 1
  },
  methods: {
    //添加
    addfn()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 125, _exp: `id > 0 and type = ${this.form.type}`, orderby: 'id DESC'}
      window.post.getPost(paras).then((ret) =>
      {
        let obj = {
          cmd: 'add',
          _major: 11,
          _minor: 125,
          retAtt: 1,
          type: this.form.type,
          question: this.form.question,
          answer: this.form.answer,
          addtime: (Date.parse(new Date()) / 1000),
          orders: ret.length + 1
        }
        window.post.getPost(obj).then((ret) =>
        {
          if (ret.ret === 1)
            this.$message({message: '添加失败，请检查是否有未填写的内容或者填写不规范', type: 'error', customClass: 'mzindex'})
          else
          {
            this.$message({message: '添加成功', type: 'success', customClass: 'mzindex'})
            this.$emit('removeTab')
            this.$store.commit('onIsLb', '1')
          }
        })
      })
    },
    //获取需要修改的数据
    isgetData()
    {
      if (this.$route.path === '/KyzxfwUpdate')
        this.getData()
      else if (this.$route.path === '/KyzxLook')
        this.getData()
      else if (this.$route.path === '/Kyzxfwgl')
        return false
    },
    getData()
    {
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 125,
        _exp: 'id=?',
        types: 'i',
        vals: this.updataID
      }
      window.post.getPost(paras).then((ret) =>
      {
        this.form.id = ret[0].id
        this.form.question = ret[0].question
        this.form.answer = ret[0].answer
        this.form.type = ret[0].type
      })
    },
    //修改
    modification()
    {
      let obj = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 125,
        retAtt: 1,
        id: this.form.id,
        type: this.form.type,
        question: this.form.question,
        answer: this.form.answer
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '修改失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '修改成功', type: 'success', customClass: 'mzindex'})
          this.dialogVisible = false
          this.$router.push({path: '/Kyzxfwgl'})
          this.$store.commit('onActiveName', '1')
        }
      })
    },
    //返回
    backtrack()
    {
      this.$router.push({path: '/Kyzxfwgl'})
      this.$store.commit('onActiveName', '1')
    },
    backtrackLook()
    {
      this.$router.push({path: '/ToExamine'})
      this.$store.commit('onActiveName', '1')
    },
    // 点击不通过
    notPass()
    {
      this.dialogFormVisible = true
      // let objcontent = {
      //   cmd: 'updateAtt',
      //   _major: 11,
      //   _minor: 1,
      //   retAtt: 1,
      //   id: this.updataID,
      //   examine: 4
      // }
      // window.post.getPost(objcontent).then((ret) =>
      // {
      //   if (ret.ret === 1)
      //     this.$message({message: '审核失败', type: 'error', customClass: 'mzindex'})
      //   else
      //   {
      //     this.$message({message: '该条已为不通过', type: 'error', customClass: 'mzindex'})
      //     this.dialogVisible = false
      //     this.$router.push({path: '/ToExamine'})
      //     this.$store.commit('onActiveName', '1')
      //   }
      // })
    },
    // 确定不通过
    modificaNopass()
    {
      let objcontent = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 1,
        retAtt: 1,
        id: this.updataID,
        examine: 4,
        exuser: this.username,
        extime: (Date.parse(new Date()) / 1000),
        exopinion: this.forms.textareas
      }
      window.post.getPost(objcontent).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '审核失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '该条已为不通过', type: 'error', customClass: 'mzindex'})
          this.dialogVisible = false
          this.$router.push({path: '/ToExamine'})
          this.$store.commit('onActiveName', '1')
        }
      })
    },
    //通过
    isPass()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 1, _exp: `id = ${this.updataID}`}
      window.post.getPost(paras).then((ret) =>
      {
        this.examineInfo = ret[0].examine
        let userInfo = JSON.parse(localStorage.getItem('userMsg'))
        let examine = null
        if (userInfo.role.includes(1) && this.examineInfo === 1)
          examine = 2
        else if (userInfo.role.includes(2) && this.examineInfo === 2)
          examine = 3
        else if (userInfo.role.includes(3) && this.examineInfo === 3)
          examine = 5
        else if (userInfo.role.includes(0))
          examine = 0
        this.upExamine(examine)
      })
    },
    //修改状态
    upExamine(examine)
    {
      let objcontent = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 1,
        retAtt: 1,
        id: this.updataID,
        examine: examine,
        exuser: this.username,
        extime: (Date.parse(new Date()) / 1000)
      }
      window.post.getPost(objcontent).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '审核失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '审核成功', type: 'success', customClass: 'mzindex'})
          this.$router.go(-1)
        }
      })
    },
    //上传图片
    getPhoUrl()
    {
      let that = this
      window.public.onUploadPicture(that)
    },
    //图片上传之前的钩子
    beforeUploadPicture(file)
    {
      let that = this
      window.public.beforeUploadPicture(file, that)
    },
    //上传中
    handlePictureCardPreview(file)
    {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    //图片上传成功
    onSuccess(response)
    {
      let that = this
      window.public.onSuccess(response, that)
    },
    //上传发生变化（上传或者删除）
    handleEditChange(file, fileList)
    {
      let that = this
      window.public.handleEditChange(file, fileList, that)
    },
    //删除图片
    handleRemovePicture(fileList)
    {
      let that = this
      window.public.handleRemovePicture(fileList, that)
    },
    //超出上传次数
    exceed()
    {
      this.$message({message: '您已上传过了，若需要换一个，请先删除上一个', type: 'error', customClass: 'mzindex'})
    },
    //取消(移除Tabs页)
    cancelfn()
    {
      this.$emit('removeTab')
    },
    /**
     * 标题检测
     * @param {String} major 主类型
     * @param {String} minor 子类型
     * @param {String} title 标题
     */
    detection(major, minor, title)
    {
      let that = this
      window.public.detection(major, minor, title, that)
    },
    //判断是否必填
    isMandatory(colname)
    {
      return window.public.isMandatory(this.fldData, colname)
    },
    //判断富文本内容是否必填
    isContentMandatory(colname)
    {
      return window.public.isMandatory(this.fldContentData, colname)
    },
    // 重新发布
    republish()
    {
      let objcontent = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 1,
        retAtt: 1,
        id: this.updataID,
        examine: 1,
        exuser: '',
        extime: null,
        exopinion: ''
      }
      window.post.getPost(objcontent).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '重新发布失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '重新发布成功', type: 'success', customClass: 'mzindex'})
          this.$router.go(-1)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// static/form/KyzxfwAdd.vue